import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BatchEmailUploadTemplateModel } from '../../../models/batch-email.model';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-batch-upload-template',
  templateUrl: './batch-upload-template.component.html',
  styleUrls: ['./batch-upload-template.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class BatchUploadTemplateComponent implements OnInit {
  @ViewChild('fileInputUpload', { static: true }) fileInputUpload!: ElementRef;
  @ViewChild('uf', { static: true }) ngForm!: NgForm;
  uploadTemplateModel!: BatchEmailUploadTemplateModel;
  loadUploadDialog = false;
  umsgs: any[] = [];
  sucessmsg: any[] = [];
  filesUpload: any = [];
  disableUpload = false;
  fileUploadSpinners = false;
  showUploadedFiles = false;

  constructor(
    private settingsServices: SettingsService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.cancelUploadDocument();
    this.resetForm();
  }

  onSubmit() {
    if (
      this.uploadTemplateModel.Name?.trim() != '' &&
      this.uploadTemplateModel.Description?.trim() != ''
    ) {
      this.loadUploadDialog = true;
    }
  }

  fileuploding(formData: any) {
    const uploadUrl =
      this.settingsServices.baseUrl +
      'api/Notification/UploadEmailTemplateFile/';

    this.http
      .post<BatchEmailUploadTemplateModel[]>(uploadUrl, formData)
      .subscribe(
        (efRes: any) => {
          if (efRes) {
            this.loadUploadDialog = false;
            this.cancelUploadDocument();
            this.resetForm();
            this.sucessmsg.push({
              severity: 'success',
              detail: `Template ${efRes.templateName} Uploaded Successfully`
            });
            setTimeout(() => {
              this.sucessmsg = [];
            }, 3000);
          }
        },
        error => {
          this.umsgs = [];
          if (error.status === 500) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else if (error.status === 502) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else if (error.status === 400) {
            this.umsgs.push({
              severity: 'error',
              detail: 'Requierd Subject or Body is missing'
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else {
            this.umsgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while uploading a file'
            });
            this.fileUploadSpinners = false;
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          }
          this.fileUploadSpinners = false;
        }
      );
  }

  uploadFile(event) {
    if (this.fileInputUpload.nativeElement.files.length > 0) {
      this.fileInputUpload.nativeElement.disabled = true;
      this.disableUpload = true;
    }
    for (const fileUpload of event) {
      const ext = fileUpload.name.substring(
        fileUpload.name.lastIndexOf('.') + 1
      );
      if (ext.toLocaleLowerCase() === 'oft') {
        if (fileUpload.size > 10485760) {
          this.umsgs.push({
            severity: 'error',
            detail: fileUpload.name + 'files is greater than 10 Mb'
          });
          setTimeout(() => {
            this.umsgs = [];
          }, 4000);
        } else {
          if (
            this.filesUpload.find(
              (a: { Name: string }) => a.Name === fileUpload.name
            ) === undefined
          ) {
            if (
              this.filesUpload.length === 0 ||
              this.filesUpload.length !== 1
            ) {
              this.filesUpload.push(fileUpload);
            } else {
              this.umsgs = [];
              this.umsgs.push({
                severity: 'error',
                detail: 'Possible upload only one file in list'
              });
              setTimeout(() => {
                this.umsgs = [];
              }, 4000);
            }
          } else {
            this.umsgs = [];
            this.umsgs.push({
              severity: 'error',
              detail: this.filesUpload.name + ' file already exits in list'
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          }
        }
      } else {
        this.resetUploadElement();
        this.umsgs.push({
          severity: 'error',
          detail: 'Accepted File type OFT'
        });
        setTimeout(() => {
          this.umsgs = [];
        }, 4000);
      }
    }
  }

  cancelUploadDocument() {
    this.loadUploadDialog = false;
    this.resetUploadElement();
  }
  resetUploadElement() {
    this.filesUpload = [];
    this.fileInputUpload.nativeElement.value = '';
    this.fileInputUpload.nativeElement.disabled = false;
    this.disableUpload = false;
    this.fileUploadSpinners = false;
  }
  resetForm() {
    this.ngForm.resetForm();
    this.uploadTemplateModel = {} as BatchEmailUploadTemplateModel;
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  submitSelectedFile() {
    if (this.filesUpload.length > 0) {
      const file = this.filesUpload[0] as File;
      const formData = new FormData();
      formData.append('file', file, file.name);
      formData.append('OFTName', this.uploadTemplateModel.Name || '');
      formData.append(
        'OFTDescription',
        this.uploadTemplateModel.Description || ''
      );
      formData.append('Content-Type', 'application/vnd.ms-outlook');
      this.fileUploadSpinners = true;
      this.fileuploding(formData);
    } else {
      this.umsgs.push({ severity: 'error', detail: 'No files selected' });
      setTimeout(() => {
        this.umsgs = [];
      }, 1000);
    }
  }

  dragDropUploadFile(event) {
    if (this.filesUpload.length > 0) {
      return;
    }
    this.fileInputUpload.nativeElement.disabled = true;
    this.disableUpload = true;
    this.uploadFile(event);
  }

  removeSelectedFile() {
    this.resetUploadElement();
  }
}
